module.exports = __webpack_public_path__ + "img/HT.8a181e6f.png";